import Marquee from "react-fast-marquee";
import { BUSINESS } from "@/data/business";

export const BrandMarquee = () => {
  return (
    <div data-testid="brand-marquee" className="border-y border-[#222222] bg-[#FF3B30] py-4 md:py-5">
      <Marquee speed={40} gradient={false} autoFill>
        {BUSINESS.brands.map((b) => (
          <span
            key={b}
            className="mx-8 text-[#050505] font-mono-plex font-bold uppercase tracking-widest text-sm md:text-lg flex items-center gap-8"
          >
            {b}
            <span className="text-[#050505]/50">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default BrandMarquee;
